import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router';
import { PREVIEW_MODE_DATE_PARAM, cleanEffectiveDateTime } from '../../utils/preview-mode-utils';

export enum ServerEffectiveDateTimeQueryKey {
    SERVER_EFFECTIVE_DATE_TIME = 'server-effective-date-time',
}

export const useServerEffectiveDateTime = (): string => {
    const location = useLocation();
    const initialData = useMemo(
        () =>
            cleanEffectiveDateTime(
                new URLSearchParams(location.search).get(PREVIEW_MODE_DATE_PARAM),
            ),
        [location.search],
    );
    const queryResult = useQuery<string>({
        queryKey: [ServerEffectiveDateTimeQueryKey.SERVER_EFFECTIVE_DATE_TIME],
        initialData,
        queryFn: (): string => initialData,
        // Only run on the server side, but the data stays hydrated on the client side
        enabled: typeof window === 'undefined',
    });
    return queryResult.data ?? '';
};
